import { Component, Input, OnInit } from '@angular/core';
import { LinkRef } from '@kion/data-models';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'kion-support-banner',
  templateUrl: './support-banner.component.html',
  styleUrls: ['./support-banner.component.scss']
})
export class SupportBannerComponent implements OnInit {

  @Input() title: {title: string, titleSize: string};
  @Input() subtitle: string;
  @Input() support: {phone: string, mailAddress: string, contactFormUrl: LinkRef|string, openingHours: string};

  @Input() topStyle: string;
  @Input() background: string;

  openingHours: string;
  emailLink: string;
  faqLink: string;

  constructor(private translateService: TranslateService) { }

  ngOnInit(): void {
    console.log(this.support);
    this.openingHours = '<span class="opening-hours">' + this.support.openingHours + '</span>';
    this.emailLink = '<a href="mailto:'+ this.support.mailAddress + '">' + this.translateService.instant('customerSupport.email.headline') + '</a>';
    this.faqLink = '<a href="' + this.support.contactFormUrl + '"> ' + this.translateService.instant('customerSupport.contact.headline') + ' </a>'
  }

}
